<template>
	<div class="basis-page-cls">
		<section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :modal-append-to-body="false" :defaultQuery="listQuery" @filterSearch="filterSearch" pageNumber="pageNum" />
		</section>
		<div class="basis-cls_table">
			<div class="header">
			    <span class="title el-icon-document"> 数据列表</span>
			    <div class="btns">
			        <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" class="right" @click="onAdd">新增</el-button>
				</div>
			</div>
			<table-pagination ref="tableItem" pagination layout="prev,pager,next,total" :data="data" :column="column" v-loading="loading"
				:total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />
		</div>
		<!-- 编辑/新增弹框 -->
		<el-drawer size="35%" :title="dialogTitle" :visible.sync="drawer" direction="rtl" :wrapperClosable="false" class="customer-drawer-common">
			<section>
				<el-form :model="form" style="margin-top: 26px;" ref="form" :rules="formRules">
					<el-form-item label="技能组名称:" :label-width="formLabelWidth" prop="skillName">
						<el-input placeholder="请输入技能组" v-model="form.skillName" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="品牌:" :label-width="formLabelWidth" prop="childBrand">
						<el-select v-model="form.childBrand" placeholder="请选择品牌">
							<el-option v-for="item in brand_groups" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="接线量：" :label-width="formLabelWidth" prop="defaultNum">
						 <el-input-number v-model="form.defaultNum"  :min="1"></el-input-number>
					</el-form-item>
				</el-form>
				<div class="footer">
						<el-button @click="drawer = false"  size="mini">取 消</el-button>
						<el-button type="primary" size="mini" @click="onSave" :loading="loadingBtn">{{ loadingBtn ? '提交中 ...' : '确 定' }}
						</el-button>
				 </div>
			</section>
		</el-drawer>
		<!-- 人管管理 -->
	   <PeopleBox ref="peopleBox"/>
	</div>
</template>
<script>
	import { mapGetters,mapState } from "vuex";
	import PeopleBox from './people'
	export default {
		components:{
			PeopleBox
		},
		computed:{
			 ...mapGetters([
				'subBrandList',
			]),
			...mapState({
				userInfo:state => state.user.userInfo
			}),
		},
		data() {
			return {
				dialogTitle: "新增技能组",
				drawer: false,
				brand_groups: [],
				formLabelWidth: "90px",
				form: {
					skillName: "",
					brand: this.$store.state.user.brandId,
					childBrand:'',
					defaultNum: 1,
					skillId:''
				},
				formRules:{
					skillName:[{ required: true, message: '请输入技能组', trigger: 'blur' }],
					childBrand:[{ required: true, message: '请选择品牌', trigger: 'change' }],
					defaultNum:[{ required: true, message: '请输入接线量', trigger: 'change' }],
				},
				filterHeader: [
					{ label: '品牌', model: 'childBrand', type: 'select', default: '', list: [] },
					{ label: '技能组', model: 'skillName', type: 'input', default: '', placeholder: '请输入技能组名称' },
				],
				listQuery: {
					brand:this.$store.state.user.brandId,
					childBrand: "",
					pageNum: 1,
					pageSize: 10,
					skillName:''
				},
				data: [],
				column: [
					{
						label: "序号",
						prop: "index",
						type: "index"
					},
					{
						label: "技能组ID",
						prop: "skillId" ,
					 },
					{
						label: "技能组名称",
						prop: "skillName"
					},
					{
						label: "品牌",
						prop: "childBrandName"
					},
					{
						label: "默认接线量",
						prop: "defaultNum"
					},
					{
						label: "创建时间",
						prop: "createTime",
						sortable: true,
						render:(h,scope) => {
							return <span>{this.$dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm")}</span>
						}
					},
					{
						label: "操作",
						prop: "cation",
						align: "center",
						width: 150,
						fixed:'right',
						render: (h, scope) => {
						  return (
						    <div class="operate-inline">
						      <el-button type="text" size="small" onClick={() => this.onEdit(scope.row)} >
						        编辑
						      </el-button>
							  <el-divider direction="vertical"></el-divider>
							  <el-button type="text" size="small" onClick={() => this.onPeople(scope.row)}>
							      人员管理
							  </el-button>
							 </div>
						  );
						}
					}
				],
				total: 0,
				loading:false,
				loadingBtn:false
			};
		},
		methods: {
			filterSearch(query) {
				this.listQuery = Object.assign(this.listQuery, query);
			    this.getData();
			},
			getList(val) {
				this.listQuery.pageNum = val.page
				this.getData()
			},
			onSave(){
				let params = JSON.parse(JSON.stringify(this.form))
				let url = this.dialogTitle == '新增技能组' ? 'add' : 'update'
				if(this.dialogTitle == '新增技能组'){
					delete params.skillId
				}
				this.$refs.form.validate((valid) => {
					if(valid) {
						this.loadingBtn = true
						this.$api.postSystemSkillGroup(url,params).then(res => {
							this.loadingBtn = false
							if(res.errcode == 0){
								this.$message.success(`${this.dialogTitle}成功`)
								this.drawer = false
								this.getData();
								this.$store.dispatch('app/StoreGetApp',this.userInfo)
							}
						}).catch(err => {
							this.loadingBtn = false
						})
					}
				})
			},
			onEdit(row) {
				this.brand_groups = this.filterHeader[0]['list']
				let keys = Object.keys(this.form);
				this.loadingBtn = false
				keys.map(item => {
					this.form[item] = row[item]
				})
				this.dialogTitle = "修改技能组";
				this.drawer = true;
			},
			onAdd() {
				this.loadingBtn = false
				this.dialogTitle = "新增技能组";
				this.drawer = true;
				this.brand_groups = this.filterHeader[0]['list']
				this.$nextTick(() => {
					this.$refs.form.resetFields();
				});
			},
			resetTools(){
				this.listQuery.skillName = ''
				this.listQuery.childBrand = ''
				this.listQuery.pageNum = 1
				this.getData()
			},
			getData(){
				this.loading = true;
				let params = {
					pageNum:this.listQuery.pageNum,
					pageSize:this.listQuery.pageSize,
					data: {
						brand: this.listQuery.brand,
						childBrand: this.listQuery.childBrand,
						skillName:  this.listQuery.skillName,
					}
				}
				this.$api.getSystemSkillGroup(params).then(res => {
					this.loading = false
					if(res.errcode == 0) {
						this.data = res.list
						this.total = res.total
					}
				})
			},
			// 人员管理
			onPeople(row){
				this.$refs.peopleBox.onOpen(row)
			}
		},
		async created(){
			await this.getData();
			this.filterHeader[0]['list'] = await this.subBrandList;
		}
	};
</script>

